import React, { useState, useEffect } from "react";
import { FaCalendarAlt, FaEnvelope } from "react-icons/fa";
import { holidayService } from "../services/holidayService";
import { useUserProfiles } from "../contexts/UserProfileContext";
import "./HolidayBanner.css";

function HolidayBanner({ onNavigateToGreetingCards, hasSubscription = false }) {
  const { activeProfile } = useUserProfiles();
  const [upcomingHolidays, setUpcomingHolidays] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed] = useState(false);

  useEffect(() => {
    // Only show to paid/subscribed users
    if (!hasSubscription) {
      return;
    }

    const holidays = holidayService.getUpcomingHolidays(3);

    if (holidays.length > 0) {
      setUpcomingHolidays(holidays);
      setIsVisible(true);
    }
  }, [activeProfile, hasSubscription]);

  const handleNavigate = () => {
    if (onNavigateToGreetingCards) {
      onNavigateToGreetingCards();
    }
    setIsVisible(false);
  };

  if (!isVisible || isDismissed || upcomingHolidays.length === 0) {
    return null;
  }

  const nextHoliday = upcomingHolidays[0];
  const daysUntil = holidayService.getDaysUntil(nextHoliday.date);

  const urgencyText =
    daysUntil === 0
      ? "Today!"
      : daysUntil === 1
      ? "Tomorrow!"
      : `${daysUntil} days away!`;

  return (
    <div className="holiday-banner game-card-style">
      <div className="banner-content">
        <div className="banner-icon">
          <FaCalendarAlt />
        </div>

        <div className="banner-text">
          <div className="banner-title">
            {nextHoliday.name} is {urgencyText}
          </div>
          <div className="banner-subtitle">
            Create personalized greeting cards at our boutique
          </div>
        </div>

        <button className="banner-cta" onClick={handleNavigate}>
          <FaEnvelope />
          Make Cards
        </button>
      </div>

      {upcomingHolidays.length > 1 && (
        <div className="additional-holidays">
          <span>Also coming up: </span>
          {upcomingHolidays.slice(1).map((holiday, index) => (
            <span key={index} className="additional-holiday">
              {holiday.name}
              {index < upcomingHolidays.length - 2 && ", "}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default HolidayBanner;
